import { useEffect, useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { api, errorMessage } from "../../services/api.js";
import { ErrorAlert } from "../../components/ui/index.js";
import { BrandMark } from "../../components/ui/Brand.js";
import { DemoBanner } from "../../components/ui/DemoBanner.js";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [demoMode, setDemoMode] = useState(false);

  useEffect(() => {
    api
      .publicStatus()
      .then((s) => setDemoMode(s.demoMode))
      .catch(() => {});
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(email, password);
      const next = params.get("next");
      // Solo rutas internas del panel (evita redirecciones abiertas).
      navigate(next && next.startsWith("/") && !next.startsWith("//") ? next : "/dashboard", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="grid min-h-full lg:grid-cols-[1.1fr_1fr]">
      {/* Panel de marca al estilo del hero de damateur.com.mx */}
      <section className="relative hidden overflow-hidden bg-ink p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <img src="/brand/damateur-icon-512.png" alt="" className="pointer-events-none absolute -right-24 top-12 w-[560px] opacity-10" />
        <BrandMark size={40} />
        <div className="relative max-w-md">
          <p className="font-util text-xs uppercase tracking-[0.34em] text-aqua">Formación · Diseño · Investigación</p>
          <p className="mt-6 font-display text-5xl font-extrabold leading-[0.95] tracking-tight">
            Atención visual<span className="text-aqua">.</span>
          </p>
          <p className="mt-6 text-white/75">
            Laboratorio de mapas de atención estimada con webcam: compara cómo distintos grupos de edad observan una misma fotografía.
          </p>
        </div>
        <p className="font-util text-xs uppercase tracking-[0.18em] text-white/40">GazeLab - Damateur</p>
      </section>
      <div className="flex items-center justify-center p-6">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-4 p-6" aria-labelledby="login-title">
        <div>
          <div className="mb-4 lg:hidden">
            <BrandMark tone="light" />
          </div>
          <p className="eyebrow">Panel del investigador</p>
          <h1 id="login-title" className="mt-1 text-2xl font-bold text-ink">
            Iniciar sesión
          </h1>
        </div>
        {demoMode && <DemoBanner />}
        <ErrorAlert error={error} />
        <div>
          <label htmlFor="email" className="label">
            Correo electrónico
          </label>
          <input id="email" type="email" autoComplete="username" required className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <label htmlFor="password" className="label">
            Contraseña
          </label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit" className="btn-primary w-full" disabled={busy}>
          {busy ? "Entrando…" : "Entrar"}
        </button>
        <p className="text-center text-xs text-slate-500">Colectivo de investigación en diseño industrial · FARQ UANL</p>
      </form>
      </div>
    </main>
  );
}
